import styled from "styled-components";
import FlexBox from "components/layouts/FlexBox/FlexBox";
import { Form } from "components";

export const StyledFlexBox = styled(FlexBox)`
  width: 100%;
  max-width: 31.25rem;
  margin-left: auto;
`;

export const DragWrapper = styled.div`
  background-color: #ffffff;
  padding: 1rem;
  border-radius: 0.5rem;

  .drag-and-drop-zone {
    border-color: #ebe9e6;

    > div {
      padding: 3rem 1rem;
    }
  }
`;

export const StyledForm = styled(Form)`
  background: #f8f7f5;
`;

export const StyledSpan = styled.span`
  font-family: Verizon-NHG-eDS, Helvetica, Arial, Sans-serif;
`;
